import { CSSProperties, ReactElement, useState } from 'react';
import { ButtonView } from '@vivli/shared/views';

const buttonStyle: CSSProperties = {
    paddingBottom: 10,
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 10,
    minHeight: 50,
    minWidth: 180,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 0,
};

interface ContinueComponentProps {
    userAcknowledged: (acknowledged: boolean) => void;
    messageToUser?: string | ReactElement;
}

export const ContinueComponent = ({ userAcknowledged, messageToUser }: ContinueComponentProps) => {
    const handleButtonClick = () => {
        userAcknowledged(true);
    };

    return (
        <div style={{ textAlign: 'center', marginTop: 25 }} className="vmView_continueComponent">
            {messageToUser && <div style={{ marginBottom: 10 }}>{messageToUser}</div>}
            <ButtonView style={buttonStyle} onClick={handleButtonClick} className="vmView_continueButton">
                Continue
            </ButtonView>
        </div>
    );
};
